module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "ranking-card"
  }, [_c('div', {
    staticClass: "ranking-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("热销产品TOP20")]), _vm._v(" "), _c('div', {
    staticClass: "ranking-actions"
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px",
      "margin-right": "10px"
    },
    attrs: {
      "placeholder": "在列表中搜索产品名称",
      "prefix-icon": "el-icon-search",
      "size": "small"
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  })], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredProducts,
      "border": "",
      "stripe": ""
    },
    on: {
      "row-click": _vm.handleRowClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "排名",
      "width": "80",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var $index = ref.$index;

        return [_c('div', {
          staticClass: "rank-cell",
          class: _vm.getRankClass($index + 1)
        }, [_vm._v("\n          " + _vm._s($index + 1) + "\n        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "产品信息",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', {
          staticClass: "product-info-cell"
        }, [_c('el-image', {
          staticClass: "product-thumb",
          attrs: {
            "src": row.picture,
            "fit": "cover",
            "preview-src-list": [row.picture]
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "product-details"
        }, [_c('div', {
          staticClass: "product-name"
        }, [_vm._v(_vm._s(row.productName))]), _vm._v(" "), _c('div', {
          staticClass: "product-meta"
        }, [_c('span', {
          staticClass: "product-category"
        }, [_vm._v(_vm._s(row.productClassifyName))]), _vm._v(" "), _c('span', {
          staticClass: "product-spec"
        }, [_vm._v(_vm._s(row.spec))])])])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalSales",
      "label": "销售量(箱)",
      "width": "120",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n        " + _vm._s(_vm._f("formatNumber")(row.totalSales)) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalAmount",
      "label": "销售额(元)",
      "width": "150",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n        " + _vm._s(_vm._f("formatCurrency")(row.totalAmount)) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "单价(元)",
      "width": "120",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n        " + _vm._s(_vm._f("formatCurrency")(row.price)) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.openTrend(row.productId)
            }
          }
        }, [_vm._v("销售趋势")])]
      }
    }])
  })], 1), _vm._v(" "), _c('ProductSalesTrendDrawer', {
    attrs: {
      "product-id": _vm.selectedProductId
    },
    on: {
      "close": _vm.handleDrawerClose
    },
    model: {
      value: (_vm.drawerVisible),
      callback: function($$v) {
        _vm.drawerVisible = $$v
      },
      expression: "drawerVisible"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53048fd8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataSheet/utils/ProductRankingTable.vue
// module id = 1009
// module chunks = 3